import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=76a223cb&"
import script from "./Flag.vue?vue&type=script&lang=ts&"
export * from "./Flag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76a223cb')) {
      api.createRecord('76a223cb', component.options)
    } else {
      api.reload('76a223cb', component.options)
    }
    module.hot.accept("./Flag.vue?vue&type=template&id=76a223cb&", function () {
      api.rerender('76a223cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/campaign/Flag.vue"
export default component.exports